import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { HeartHandshake, ClipboardList, CalendarCheck, CheckCircle2, Clock, UserCircle2, LogOut } from "lucide-react";
import { useAuth } from "../../lib/auth";
import api from "../../lib/api";

const NAV = [
  { to: "/chaplain-portal/dashboard", label: "My Assignments", icon: ClipboardList, end: true },
  { to: "/chaplain-portal/follow-up", label: "Follow-Up Due", icon: CalendarCheck },
  { to: "/chaplain-portal/completed", label: "Completed Care", icon: CheckCircle2 },
  { to: "/chaplain-portal/history", label: "My Activity / History", icon: Clock },
  { to: "/chaplain-portal/profile", label: "Profile", icon: UserCircle2 },
];

export default function ChaplainPortalLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/chaplain-portal/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC]" data-testid="chaplain-portal-shell">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/chaplain-portal/dashboard" className="flex items-center gap-3">
            <div className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-[#4A6FA5] text-white">
              <HeartHandshake className="w-5 h-5" strokeWidth={1.75} />
            </div>
            <div>
              <p className="font-heading text-sm text-slate-900 leading-tight">CCCHAPS Chaplain Portal</p>
              <p className="text-xs text-slate-500 leading-tight">Confidential chaplain workspace</p>
            </div>
          </Link>
          <div className="flex items-center gap-3">
            <p className="hidden sm:block text-sm text-slate-600" data-testid="chaplain-portal-user">
              {user?.name || user?.email}
            </p>
            <button
              type="button"
              onClick={doLogout}
              data-testid="chaplain-portal-signout"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium text-slate-700 border border-slate-200 hover:bg-slate-50"
            >
              <LogOut className="w-3.5 h-3.5" /> Sign out
            </button>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 grid lg:grid-cols-[220px_1fr] gap-8">
        <aside className="lg:sticky lg:top-8 self-start">
          <nav className="bg-white border border-slate-200 rounded-2xl p-2" data-testid="chaplain-portal-nav">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={`chaplain-nav-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                    isActive ? "bg-[#4A6FA5] text-white" : "text-slate-700 hover:bg-slate-50"
                  }`
                }
              >
                <n.icon className="w-4 h-4" strokeWidth={1.75} /> {n.label}
              </NavLink>
            ))}
          </nav>
          <p className="mt-3 text-xs text-slate-500 px-2">
            You see only records assigned to you. Reminder: CCCHAPS is not an emergency service. Emergencies should be directed to 911.
          </p>
        </aside>
        <main>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
